<template>
    <el-dialog v-model="dialogVisible" :title="dialogTitle" :before-close="handleClose">
        <!-- <span>
            撒大声地撒111
        </span> -->
        <el-form :model="form" label-width="auto" style="max-width: 700px">
            <el-form-item label="宿舍列表">
                <div class="dormitory_list_box">
                    <el-tag v-for="tag in dormList" :key="tag.name" closable @close="tagclose(tag)" :type="tag.type">
                        {{ tag.name }}
                    </el-tag>

                </div>
                <div class="add_box" @click="addClick()">
                    + 添加
                </div>
            </el-form-item>
        </el-form>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="handleClose">取消</el-button>
                <el-button type="primary" @click="preserveClick()">
                    确认
                </el-button>
            </div>
        </template>
    </el-dialog>
    <el-dialog v-model="dialogVisibleOn" v-if="dialogVisibleOn" title="选择学生" :before-close="handleOn"  class="popup_box">
        <el-form ref="form" :model="form" label-width="80px">
            <el-input v-model="form.studentName" placeholder="请输入姓名"></el-input>
            <el-select v-model="form.gradeId" placeholder="请选择年级" @change="classClick">
                <el-option :label="item.name" :value="item.id" v-for="item in options" :key="item.id"></el-option>
            </el-select>
            <el-select v-model="form.classId" placeholder="请选择班级">
                <el-option :label="item.name" :value="item.id" v-for="item in classList" :key="item.id"></el-option>
            </el-select>
            <el-select v-model="form.sex" class="nianling" placeholder="性别">
                <el-option label="男" value="1"></el-option>
                <el-option label="女" value="0"></el-option>
            </el-select>
            <div class="cha_xun" @click="queryClick()">查询</div>
            <div class="chong_zhi" @click="emptyBtn">重置</div>
            <!-- <div class="rig-box">选择</div> -->
        </el-form>
        <el-table :data="tableData" border style="width: 100%" class="table_box"   
        height="450" @selection-change="handleSelectionChange" tooltip-effect="dark" >
             <el-table-column
                type="selection"
                width="50">
            </el-table-column>
            <el-table-column
                type="index"
                label="序号"
                >
            </el-table-column>
            <el-table-column prop="name" label="学生姓名" >
            </el-table-column>
            <!-- <el-table-column prop="deviceId" label="终端号码" >
                <template #default="scope">
                    <span>{{ scope.row.deviceId }}</span>
                </template>
            </el-table-column> -->
            <el-table-column prop="gradeName" label="年级/班级" >
                <template #default="scope">
                    <!-- <el-button>选择</el-button> -->
                    <span>{{scope.row.gradeName}}/{{ scope.row.className }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="sex" label="性别" >
                <template #default="scope">
                    <!-- <el-button>选择</el-button> -->
                    <span>{{scope.row.sex==0?'女':'男'}}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="操作"
                >
                <template #default="scope">
                    <el-button @click="selectStudents(scope.row)" >选择</el-button>
                    <!-- <span @click="selectStudents(scope.row)" class="xuanze_box">选择</span> -->
                </template>
            </el-table-column>
        </el-table>
       <div  class="fen_ye">
            <el-pagination
            class="fen_ye_box"
                layout="prev, pager, next"
                :total="total" @current-change="handleCurrentChange">
            </el-pagination>
       </div>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="handleOn()">取消</el-button>
                <el-button type="primary" @click="selectStudents()">
                    确认
                </el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import {
    studentList,
    findStudent,
    addStudent
} from '@/assets/api/schoollog.js'
import { findTeacherInfo,gradeList,findClassList  } from '@/assets/api/renyuan';
export default {
    props: ['alterAddItem'],
    components: {

    },
    data() {
        return {
            form: {
                name: '',
                classId: '',
                gradeId: '',
                studentName:''
            },
            dialogVisible: true,
            dialogTitle: true,
            dormList: [],
            dialogVisibleOn: false,
            tableData: [],
            multipleChoiceList: [],
            teacherObj: {},
            options: [],
            classList: [],
            pageValue:1,
            total:'',
        };
    },
    created() {
        this.findStudentPost()
    },
    mounted() {
        console.log(this.alterAddItem, 'item');
        this.dialogTitle = this.alterAddItem.buildingName + '-' + this.alterAddItem.name
    },
    methods: {
        emptyBtn(){
            this.form = {}
            this.studentListPost()

        },
        findStudentPost() {
            findStudent(this.alterAddItem.id).then((res)=> {
                console.log(res,'详情');
                res.data.data.forEach((item) => {
                    item.name = item.studentName
                    item.id = item.studentId
                });
                this.dormList = res.data.data
            })
        },
        handleCurrentChange (val) {
            console.log(val,9999);
            this.pageValue = val
            this.studentListPost()
        },
        queryClick () {
            this.studentListPost()
        },
        schoolClick() {
            let params = {
                page: '1',
                pageSize: '999',
            }
            gradeList(params, this.teacherObj.schoolId).then((res) => {
                console.log(res, '年级列表');
                this.options = res.data.data;
            }).catch((err) => {
                console.log(err);
            })
        },
        classClick() {
            let params = {
                page: '1',
                pageSize: '999',
            }
            findClassList(params, this.form.gradeId).then((res) => {
                console.log(res, '班级列表');
                this.classList = res.data.data;
            }).catch((err) => {
            console.log(err);
            })
        },
        Lookteacher() {
            let params = {
                userId: JSON.parse(localStorage.getItem('user')).id,
            }
            findTeacherInfo(params).then((res) => {
                console.log(res, '查看权限');
                this.teacherObj = res.data.data
                this.schoolClick()
                this.studentListPost()
            }).catch((err) => {
            console.log(err);
            })
        },
        studentListPost() {
            let params = {
                classId: this.form.classId,
                gradeId: this.form.gradeId,
                page: this.pageValue,
                pageSize: 10,
                schoolId: this.teacherObj.schoolId,
                sex: this.form.sex,
                studentName:this.form.studentName
            }
            studentList(params).then((res)=> {
                console.log(res,'学生列表111');
                this.tableData = res.data.data.data
                this.total = res.data.data.totalCount
            })
        },
        tagclose(item) {
            console.log('删除', item);
            this.dormList.splice(this.dormList.indexOf(item), 1);
        },
        handleClose() {
            console.log('取消');
            this.$emit('AddPeopleHandle')
        },
        preserveClick() {
            let ids = []
            for ( let item of this.dormList ) {
                ids.push(item.id)
            }
            let params = {
                ids
            }
            addStudent(params,this.alterAddItem.id).then((res)=> {
                console.log('保存',res);
                this.$message({
                    message: '宿舍添加人数保存成功',
                    type: 'success'
                });
                setTimeout(()=> {
                    this.handleClose()
                },1000)
            })
        },
        addClick() {
            console.log('添加');
            this.dialogVisibleOn = true
            this.multipleChoiceList = []
            this.Lookteacher()
        },
        handleSelectionChange (val) {
			console.log(val, '多选');
            this.multipleChoiceList = val
        },
        handleOn () {
            this.dialogVisibleOn = false
        },
        selectStudents(item) {
            if ( item ) {
                this.multipleChoiceList.push(item)
            } 
            this.dialogVisibleOn = false
            this.dormList = [...this.dormList,...this.multipleChoiceList ]
            this.quChong()
        },
        quChong () {
           
            this.dormList = this.dormList.filter((item, index, self) =>
                index === self.findIndex(t => t.id === item.id)
            );
        },
    },
};
</script>

<style scoped lang="scss">
.el-form {
    padding: 0px 20px;
}

.dormitory_list_box {
    width: 84%;
    padding: 10px;
    border: 1px solid #FFEBEB;
    min-height: 200px;

    .tag_box {
        padding: 2px 4px;
        margin-right: 6px;
    }

    .el-tag.el-tag--primary {
        background-color: #33CABB;
        color: #fff;
        height: 25px;
        margin-right: 6px;
    }

    /deep/ .el-tag .el-tag__close {
        color: #fff;
        margin-left: 4px
    }
}

.add_box {
    color: #fff;
    padding: 3px 6px;
    border-radius: 3px;
    background-color: #0AB1A1;
    margin-left: 10px;
    cursor: pointer;
}

.popup_box {
    .el-form {
        padding: 0px 0px;
        display: flex;
        width: 100%;
    }

    .el-input--small {
        width: 20%;
        display: inline-block;
    }

    .el-select {
        width: 15%;
        margin-left: 10px;
    }

    .nianling {
        width: 12%;

    }

    .cha_xun {
        // float: right;
        padding: 2px 6px;
        border-radius: 4px;
        color: #fff;
        margin-left: 10px;
        background-color: #0ab1a1;
        cursor: pointer;
    }

    .chong_zhi {
        padding: 2px 6px;
        border-radius: 4px;
        color: #8b95a5;
        margin-left: 10px;
        background-color: #fcfdfe;
        border: 1px solid #8b95a5;
        cursor: pointer;
    }
    .table_box {
        margin-top: 10px;
        font-size: 14px;
        text-align: center;
        .zheng_chang {
            padding: 2px 6px;
            background-color: #15C377;
            color: #fff
        }
        .xuanze_box {
            cursor: pointer;
        }
    }
    .fen_ye  {
        // text-align: right;
        height: 35px;
        position: relative;
        .fen_ye_box {
            position: absolute;
            right: 10px;
            top: 50%;
            transform: translate(0,-50%);
        }
    }
    /deep/ {
        .el-input--small .el-input__inner {
            height: 35px;
            line-height: 35px;
        }

        .el-input--small .el-input__wrapper {
            height: 35px;
            line-height: 35px;
        }

        .el-select--small .el-select__wrapper {
            line-height: 35px;
            height: 35px;
        }
    }
}

// </style>
